import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { BaseService } from './base.service';
import { Helpers } from '../helpers';
import { DataService } from '../_services/data.service';
import { Reservation } from '../models/reservation';



@Injectable()
export class SiteService extends BaseService {
    model: Reservation = new Reservation();
    constructor(protected http: Http, private dataService: DataService) {
        super('sites', http);
        this.model.publisherId = this.dataService.publisherId;
    }

    public getAllSites() {
        var url = '/sites/list?filterId=' + this.model.publisherId;
        var token = Helpers.getAccessToken();
        const headers = new Headers({
            'Content-Type': 'application/json',
            'Authorization': token
        });
        return this.http.get(url, { headers: headers })
            .map(response => response.json())
            .subscribe(data => data);
    }
}


// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/services/site.service.ts